import { ModalWindow, Button } from '@cian/ui-kit';
import * as React from 'react';
import { CalltrackingWarning } from '../CalltrackingWarning';

export interface IPhoneButtonProps {
  isCalltrackingEnabled?: boolean;
  text?: string;
  showCalltrackingWarning: boolean;
  openWarning(): void;
  clickHandler(): void;
  clickHandlerWithWarning(): void;
  closeWarning(): void;
}

export function PhoneButton({
  isCalltrackingEnabled,
  text = 'Позвонить',
  showCalltrackingWarning,
  openWarning,
  clickHandler,
  clickHandlerWithWarning,
  closeWarning,
}: IPhoneButtonProps) {
  return (
    <>
      <Button fullWidth onClick={isCalltrackingEnabled ? openWarning : clickHandler} theme="fill_primary" size="M">
        {text}
      </Button>
      <ModalWindow
        content={<CalltrackingWarning onClick={clickHandlerWithWarning} />}
        open={showCalltrackingWarning}
        fixed={false}
        onClose={closeWarning}
        size="M"
      />
    </>
  );
}
